import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-74f11e6f")

_pushScopeId("data-v-74f11e6f")
const _hoisted_1 = {
  key: 0,
  class: "num"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (!_ctx.score)
    ? (_openBlock(), _createBlock("span", _hoisted_1, "-"))
    : (_openBlock(), _createBlock("span", {
        key: 1,
        class: ["num", {'red': parseInt(_ctx.score) < 60, 'orange': parseInt(_ctx.score) >= 60 && parseInt(_ctx.score) < 80, 'green': parseInt(_ctx.score) >= 80}]
      }, _toDisplayString(parseInt(_ctx.score)) + _toDisplayString(_ctx.addZero ? '.0' : ''), 3))
})